import React, { Component } from "react";
import DevP3BpscCostForm from "./DevP3BpscCostForm/DevP3BpscCostForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

class DevP3BpscCost extends Component {
  state = {
    mode: 1
  };

  changeModeHandler = modeID => {
    this.setState({
      mode: modeID,
      proj_dev_p3_bpsc_cost_id: null
    });
  };

  componentDidMount() {
    this.props.methods.fetch();
  }

  render() {
    let smallModal = null;

    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <DevP3BpscCostForm
            currentProjectID={this.props.currentProjectID}
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentDevP3BpscCost={
              this.state.proj_dev_p3_bpsc_cost_id === null
                ? null
                : this.props.items.filter(
                    item =>
                      item.proj_dev_p3_bpsc_cost_id ===
                      this.state.proj_dev_p3_bpsc_cost_id
                  )[0]
            }
            methods={this.props.methods}
          />
        </SmallModal>
      );
    }

    const role = localStorage.getItem("project_role");
    //const DataStatusName = ["Draft", "Submitted", "Published"];
    let shownItems = this.props.items.filter(
      item => item.data_status_id === this.state.mode
    );

    const projectTableBody = shownItems.map(item => {
      return (
        <tr
          key={item.proj_dev_p3_bpsc_cost_id}
          onClick={e => {
            if (e.target.type !== "button") {
              this.setState({
                proj_dev_p3_bpsc_cost_id: item.proj_dev_p3_bpsc_cost_id
              });
              this.props.toggleSmallModalHandler();
            }
          }}
        >
          <td>{item.psc_start_year}</td>
          <td>{item.psc_complete_year}</td>
          <td>{item.notes}</td>
        </tr>
      );
    });

    return (
        <div>
            {this.props.disabled ? null : (
              <div
                  style={{textAlign: "right"}}
              >
            <Button
                color="blue"
                onClick={() => {
                  this.setState({ proj_dev_p3_bpsc_cost_id: null });
                  this.props.toggleSmallModalHandler();
                }}
            >
              Create New Dev P3 BPSC Cost
            </Button>
              </div>
            )}
      <div className="container-fluid">
        <Tabs
            onSelect={index => this.setState({
              mode: index + 1
            })}
        >
          <TabList>
            <Tab>Draft</Tab>
            {role === "ROLE_USER" ? null : (
                <Tab>Pending Approval</Tab>
            )}
            <Tab>Published</Tab>
          </TabList>
            <TabPanel></TabPanel>
            {role === "ROLE_USER" ? null : (
                <TabPanel></TabPanel>
            )}
            <TabPanel></TabPanel>
        </Tabs>

        {smallModal}
        <div>

        </div>

        <table className="table">
          <thead>
            <tr>
              <th>PSC Start Year</th>
              <th>PSC Complete Year</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>{projectTableBody}</tbody>
        </table>
      </div>
        </div>
    );
  }
}

export default DevP3BpscCost;
